import React ,{ useEffect, useState } from "react" ;
import {Link}  from 'react-router-dom'
import KycShell, { BrowserOnlyWarning } from '../components/KycShell';

const Donepage = () => {
	const [isMobile, setIsMobile] = useState(false);
	const brandlogo = localStorage.getItem('brandlogo');
	const brandname = localStorage.getItem('brandname');
	const checkIfMobile = () => {
		if (window.innerWidth <= 768) {
		  return true;
		}
		return false;
	  };

	  const updateMedia = () => {
		setIsMobile(checkIfMobile());
	  };


	  useEffect(() => {
		updateMedia();
		window.addEventListener('resize', updateMedia);
		return () => {
		  window.removeEventListener('resize', updateMedia);
		};
	  }, []);
	  useEffect(() => {
	  }, [isMobile]);
    return (
	<>
		{!isMobile && <BrowserOnlyWarning />}
		{isMobile && (
			<KycShell step={4} brandName={brandname}>
				<div className="kyc-card" style={{ textAlign: 'center', alignItems: 'center' }}>
					<div className="kyc-done-check">
						<div className="kyc-done-check__inner">
							<i className="fa fa-check" aria-hidden="true"></i>
						</div>
					</div>
					<div className="kyc-card__eyebrow">All done</div>
					<h1 className="kyc-card__title">Thank you!</h1>
					<p className="kyc-card__subtitle" style={{ maxWidth: 360 }}>
						Your verification has been submitted. Your status will update
						automatically — you can safely close this window.
					</p>
				</div>
			</KycShell>
		)}
	</>
	);
};
export default Donepage;
